
import { defineComponent } from 'vue'
import BarChart from '@/components/charts/BarChart.vue'
export default defineComponent({
  components: {
    BarChart
  }
})
